import script from "./TariffPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TariffPage.vue?vue&type=script&lang=ts&setup=true"

import "./TariffPage.vue?vue&type=style&index=0&id=12b7cfed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b7cfed"]])

export default __exports__